import ActionItemRegistry from './registry';

ActionItemRegistry.register({
  itemType: "participant-name-updated",
  buttons: "Done",
  component: "NameChange",
});

ActionItemRegistry.register({
  itemType: [
    "account-created",
    "account-updated"
  ],
  buttons: "Done/Reject",
  component: "AccountUpdateApproval"
});

ActionItemRegistry.register({
  itemType: "participant-cip",
  buttons: "Done",
  component: "CipDocuments"
});

ActionItemRegistry.register({
  itemType: "participant-terminated-review-cobra",
  buttons: "Done",
  component: "NotificationActionItem",
  values: (ai) => [{
    name: 'Termination Date', value: ai.terminationDate ? moment(ai.terminationDate).format("MM-DD-YYYY") : ''
  }]
})



// WEBPACK FOOTER //
// ./src/action-items/types/participant-update-items.js